import React from 'react';
// import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import CartSummaryItem from './CartSummaryItem';
import CartSummaryHeader from './CartSummaryHeader';
import CartSummaryFooter from './CartSummaryFooter';

function CartSummary(props) {
    const {
        isRowLoading,
        isLoading,
        detail,
        list,
        updateQuantity,
        finaliseQuantity,
        removeItem,
        currencyFormat,
        currencyDisplayCode,
        locale,
        openNoteModal
    } = props;

    return (
        <React.Fragment>
            <div
                className={`data-table ${isLoading === true &&
                    'data-table--loading'}`}
            >
                <CartSummaryHeader />
                {list.length > 0 ? (
                    <div className='data-table__body'>
                        {list.map((item, key) => {
                            const { Children = [] } = item;
                            return (
                                <React.Fragment>
                                    <CartSummaryItem
                                        key={item.ID}
                                        item={item}
                                        itemQty = {item.TotalUnitItems}
                                        isRowLoading={isRowLoading[item.ID] || false}
                                        removeItem={removeItem}
                                        updateQuantity={updateQuantity}
                                        finaliseQuantity={finaliseQuantity}
                                        currencyFormat={currencyFormat}
                                        currencyDisplayCode={currencyDisplayCode}
                                        locale={locale}
                                        openNoteModal={openNoteModal}
                                    />

                                    {Children.map((subitem) => (
                                        <CartSummaryItem
                                            key={subitem.ID}
                                            item={subitem}
                                            itemQty = {Children.length > 1 ? item.TotalUnitItems : subitem.TotalUnitItems}
                                            isRowLoading={isRowLoading[subitem.ID] || false}
                                            removeItem={removeItem}
                                            updateQuantity={updateQuantity}
                                            finaliseQuantity={finaliseQuantity}
                                            currencyFormat={currencyFormat}
                                            currencyDisplayCode={currencyDisplayCode}
                                            locale={locale}
                                            openNoteModal={openNoteModal}
                                        />
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </div>
                ) : (
                    <div className='data-table__body-empty'>
                        <div className='text-box text-box--small text-box--center'>
                            <LocalizedMessage id={'CART_NO_ITEMS'} />
                        </div>
                    </div>
                )}
                <CartSummaryFooter
                    detail={detail}
                    currencyFormat={currencyFormat}
                    currencyDisplayCode={currencyDisplayCode}
                    locale={locale}
                />
            </div>
        </React.Fragment>
    );
}

// default props
CartSummary.defaultProps = {
    // message: '',
};
// validate props
CartSummary.propTypes = {
    // message: PropTypes.string,
};

export default CartSummary;
